<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3 md4 offset-md4>
					<v-card>
						<loading v-if="isLoading" text="Admin listesi yükleniyor..." size="80" width="2"/> 
						
						<template v-if="!isLoading">
							<v-toolbar color="indigo" dark>
								<v-text-field flat solo-inverted hide-details :prepend-inner-icon="mdiMagnify"
									v-model="filterText" placeholder="Admin Ara"></v-text-field>

								<v-btn icon @click="editItem()">
									<v-icon>{{mdiPlus}}</v-icon>
								</v-btn>
							</v-toolbar>

							<v-list two-line>
								<template v-for="(item, itemIndex) in getItems">
									<v-list-item :key="itemIndex" avatar @click="editItem(item)">
										<v-list-item-avatar>
											<v-img :src="item.logo"></v-img>
										</v-list-item-avatar>
										<v-list-item-content>
											<v-list-item-title> {{item.fullname}} </v-list-item-title>
											<v-list-item-subtitle > {{item.email}} </v-list-item-subtitle>
										</v-list-item-content>
										<v-list-item-action>
											<v-btn icon v-on:click.stop.prevent="editItem(item)">
												<v-icon color="indigo">{{mdiAccountEdit}}</v-icon>
											</v-btn>
										</v-list-item-action>
									</v-list-item>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>


				<v-dialog v-model="dialogEditor" persistent max-width="600px">
					<v-card>
						<v-card-title>
							<span class="headline" v-if="item.id">Düzenle</span>
							<span class="headline" v-if="!item.id">Yeni Ekle</span>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-md>
								<v-layout wrap>
									<v-flex xs6 mb-3>
										<v-text-field label="Adı" v-model="item.firstname" outlined hide-details placeholder="Örn: Ahmet"></v-text-field>
									</v-flex>
									<v-flex xs6 mb-3>
										<v-text-field label="Soyadı" v-model="item.lastname" outlined hide-details placeholder="Örn: YESEVİ"></v-text-field>
									</v-flex>
									<v-flex xs6 mb-3>
										<v-text-field label="Email" v-model="item.email" outlined hide-details placeholder="Örn: ahmet@gmail.com"></v-text-field>
									</v-flex>
									<v-flex xs6 mb-3>
										<v-text-field label="Şifre" v-model="item.password" outlined hide-details placeholder="Örn: (8x0a&8x"></v-text-field>
										<v-checkbox class="mt-0" hide-details="" v-model="item.changePassword" color="red" label="Şifreyi değiştir" ></v-checkbox>
									</v-flex>    
									<v-flex xs12 mb-3>
										<v-divider></v-divider> 
									</v-flex>
									<v-flex xs12 > 
										<small><b>YETKİLER</b></small>
									</v-flex>
									<v-flex xs6 mb-3>
										<v-checkbox v-for="(auth,authIndex) in auths" :key="authIndex" class="mt-0" hide-details="" v-model="auth.selected" color="red" :label="auth.text" ></v-checkbox>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions class="pr-4 pl-4 pb-4"> 
							<v-btn color="error" round outlined @click="askForRemove()">Kullanıcıyı Sil</v-btn>
							<v-spacer></v-spacer> 
							<v-btn color="warning" round outlined @click="closeItem()">İptal</v-btn>
							<v-btn color="success" round outlined @click="saveItem()">Kaydet</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>



				<v-dialog v-model="dialogRemove" max-width="290">
					<v-card> 
						<v-card-title class="headline" color="error"> Silmek itediğine emin misin ?</v-card-title> 
						<v-card-actions> 
							<v-btn color="green darken-1" text  @click="closeForRemove()"> Vazgeç </v-btn> 
							<v-spacer></v-spacer>
							<v-btn color="error darken-1" text  @click="removeItem()"> EMİNİM </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>





			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	import loading from "@/components/utils/loading"
	import { mdiMagnify,mdiPlus,mdiReload,mdiCloseCircle,mdiPalette,mdiAccountEdit } from '@mdi/js';
    export default {
		components:{
			loading
		},
		data :()=>({
			mdiMagnify: mdiMagnify,
			mdiPlus: mdiPlus, 
			mdiReload: mdiReload,
			mdiCloseCircle: mdiCloseCircle,
			mdiPalette: mdiPalette,
			mdiAccountEdit: mdiAccountEdit,

			isLoading : false,
			dialogEditor : false,
			dialogRemove : false,
			auths: [],
			items: [],
			item : {},
		}), 
		mounted(){ 
			this.loadAuths();
			this.loadItems();
			this.setNewItemData();
		},
		methods:{
			loadAuths(){ 
				this.$http.get( process.env.VUE_APP_API_URL + "/admins/auths").then(response => {  
					for(var i in response.body){ response.body[i].selected = false; }
					this.auths = response.body;  
				})  
			},
			loadItems(){
				this.isLoading = true;
				this.$http.get( process.env.VUE_APP_API_URL + "/admins/", {
					params : { }
				}).then(response => {  
					this.items = response.body; 
					this.isLoading = false;
					this.dialogRemove = false;
					this.dialogEditor = false;
				})  
			},
			setNewItemData(){
				this.item = {
					id : "",
					firstname : "",
					lastname  : "",
					email : "",
					password : "",
					changePassword : false,
					auths : []
				}
			},
			editItem(item){
				this.dialogEditor = true
				if(item){
					this.item = item;
				}else{
					this.setNewItemData()
				}
				for(var i in this.auths){
					this.auths[i].selected = this.item.auths.includes(this.auths[i].value)
				}
			},
			closeItem(){
				this.dialogEditor = false
			},
			askForRemove(item){
				this.item = item;
				this.dialogEditor = false;
				this.dialogRemove = true;
			},
			closeForRemove(){ 
				this.dialogRemove = false;
			},
			saveItem(){
				this.isLoading = true;
				this.$http.post( process.env.VUE_APP_API_URL + "/admins/save", {
					id : this.item.id,
					firstname : this.item.firstname,
					lastname : this.item.lastname,
					email : this.item.email,
					password : this.item.password,
					changePassword : this.item.changePassword ? "yes" : "no",
					auths : this.getSelectedAuths
				}).then(response => {  
					this.loadItems();
				}) 
			},
			removeItem(){

			}
		},
		computed:{
			getItems(){
				return this.items
			},
			getSelectedAuths(){
				var list = [];
				for(var i in this.auths){
					if(this.auths[i].selected){
						list.push(this.auths[i].value)
					} 
				}
				return list;
			}
		}
    }
</script>